function Divider() {
    return (
        <div className="w-full bg-utilisation-white/20" style={{ height: 1 }} />
    );
}

export default Divider;
